<template>
  <div style="height:100vh">
    <iframe :src="dasrc" width="100%" height="100%"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    let token = sessionStorage.getItem("Authorization");
    let src = "https://sas.rs-smart.com:8443/AlarmStatistics?auth=" + token;
    return {
      dasrc: src
    };
  }
};
</script>

<style lang="less" scoped>
iframe{
    border: none;
    border-left:1px solid #C0c0c0;
}
</style>